import {Injectable} from '@angular/core';
import {ActivatedRouteSnapshot, RouterStateSnapshot, UrlTree} from '@angular/router';
import {Observable} from 'rxjs';

export type CanDeactivateType = Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree;

export interface CanComponentDeactivate {
	canDeactivate: () => CanDeactivateType;
}

@Injectable({providedIn: 'root'})
export class CanDeactivateGuard {

	canDeactivate(component: CanComponentDeactivate, route: ActivatedRouteSnapshot, state: RouterStateSnapshot): CanDeactivateType {
		return component?.canDeactivate ? component.canDeactivate() : true;
	}

}
